import { render, staticRenderFns } from "./inspectionTasks.vue?vue&type=template&id=0c78bffe&scoped=true"
import script from "./inspectionTasks.vue?vue&type=script&lang=js"
export * from "./inspectionTasks.vue?vue&type=script&lang=js"
import style0 from "./inspectionTasks.vue?vue&type=style&index=0&id=0c78bffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c78bffe",
  null
  
)

export default component.exports